import React from 'react'

const NotFound = () => {
    return (
        <div style={{margin:"auto"}} className="text-center">
            <h2>Page Not Found</h2>
        </div>
    )
}

export default NotFound
